import React, {
  ReactElement,
} from 'react';
import {
  DatePicker, FormGroup, Label, Loader, Select,
} from 'idsk-react-components';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import './sidePanel.scss';
import { OrganizacnaSkupinaEnum } from 'ciselniky-frontend-ts-axios';
import PrispevokVestnikaListFilter from '../../../model/PrispevokVestnikaListFilter';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';
import useOrganizacie from '../../../hooks/useOrganizacie';
import SearchInput from './SearchInput';

interface Props {
  filter: PrispevokVestnikaListFilter;
  onUpdateField?: SafeParameterSetter<PrispevokVestnikaListFilter>;
  filterCopy: PrispevokVestnikaListFilter;
  onUpdateFieldCopy: SafeParameterSetter<PrispevokVestnikaListFilter>;
  setFilter: (filter: PrispevokVestnikaListFilter) => void;
}

const MobileFilters = ({
  filter,
  onUpdateField,
  filterCopy,
  onUpdateFieldCopy,
  setFilter,
}: Props): ReactElement => {
  const {
    organizacie: organizaciaList,
    organizacieStatus: organizaciaListStatus,
  } = useOrganizacie(OrganizacnaSkupinaEnum.Vestnik);
  return (
    <div className="prispevok-vestnika-list-side-panel">
      <ExpansionPanel title="Rezort" className="stadium-procesu-container">
        <div className="slovlex-idsk-side-panel-input-wrapper rezort-container">
          <Loader loading={organizaciaListStatus.loading}>
            <Select
              id="rezort"
              width="full"
              name="rezort"
              value={filter.rezort ? filter.rezort?.uuid : ''}
              onChange={({ target }) => {
                const selectedVestnik = organizaciaList.find(vestnik => vestnik.uuid === target.value);
                onUpdateField('rezort', target.value === '' ? null : selectedVestnik);
              }}
            >
              <option key="" value="">Vyberte</option>
              {(organizaciaList && organizaciaList?.length > 0) ? (
                <>
                  {organizaciaList
                    ?.map(vestnik => (
                      <option
                        key={vestnik.uuid}
                        value={vestnik.uuid}
                      >
                        {vestnik.nazov}
                      </option>
                    ))}
                </>
              ) : (
                <option key="emptyOption" value="emptyOption" disabled>
                  Nenašiel sa žiadny záznam.
                </option>
              )}
            </Select>
          </Loader>
        </div>
      </ExpansionPanel>
      <ExpansionPanel title="Názov príspevku">
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextNazov}
          fieldName="searchTextNazov"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
          className="slovlex-idsk-side-panel-input-wrapper"
          maxLength={254}
        />
      </ExpansionPanel>
      <ExpansionPanel title="Číslo príspevku">
        <SearchInput
          filterCopy={filterCopy}
          filterSearchText={filterCopy?.searchTextCislo}
          fieldName="searchTextCislo"
          onUpdateFieldCopy={onUpdateFieldCopy}
          setFilter={setFilter}
          className="slovlex-idsk-side-panel-input-wrapper"
          maxLength={254}
        />
      </ExpansionPanel>
      <ExpansionPanel title="Ročník">
        <SearchInput
          filterSearchText={filterCopy?.searchTextRocnik}
          fieldName="searchTextRocnik"
          onUpdateFieldCopy={onUpdateFieldCopy}
          filterCopy={filterCopy}
          setFilter={setFilter}
          type="search-number"
          maxLength={4}
        />
      </ExpansionPanel>
      <ExpansionPanel title="Dátum účinnosti">
        <FormGroup>
          <FormGroup>
            <Label htmlFor="ucinnostOd">Účinný od</Label>
            <DatePicker
              id="datumUcinnostiOd"
              showIcon
              value={filter.datumUcinnostiOd}
              onChange={date => onUpdateField('datumUcinnostiOd', date)}
              strictParsing
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="ucinnostDo">Účinný do</Label>
            <DatePicker
              id="datumUcinnostiDo"
              showIcon
              value={filter.datumUcinnostiDo}
              onChange={date => onUpdateField('datumUcinnostiDo', date)}
              strictParsing
            />
          </FormGroup>
        </FormGroup>
      </ExpansionPanel>
      <ExpansionPanel title="Dátum zverejnenia">
        <FormGroup>
          <FormGroup>
            <Label htmlFor="datumZverejneniaOd">Zverejnený od</Label>
            <DatePicker
              id="datumZverejneniaOd"
              showIcon
              value={filter.datumZverejneniaOd}
              onChange={date => onUpdateField('datumZverejneniaOd', date)}
              strictParsing
            />
          </FormGroup>
          <FormGroup>
            <Label htmlFor="datumZverejneniaDo">Zverejnený do</Label>
            <DatePicker
              id="datumZverejneniaDo"
              showIcon
              value={filter.datumZverejneniaDo}
              onChange={date => onUpdateField('datumZverejneniaDo', date)}
              strictParsing
            />
          </FormGroup>
        </FormGroup>
      </ExpansionPanel>
    </div>
  );
};

export default MobileFilters;
